import type { NavItem } from '../types/content'

/**
 * Les entrées sont celles du site de la Municipalité, regroupées en quatre menus :
 * le site actuel les présente à plat, sur une seule longue liste.
 */
export const navItems: NavItem[] = [
  {
    label: 'La municipalité',
    children: [
      'Nos élus',
      'Ordres du jour',
      'Procès-verbaux',
      'Rapport financier',
      'Finances et taxation',
      'Projets',
      'Notre histoire',
    ],
  },
  {
    label: 'Services',
    children: [
      'Ordures et matières résiduelles',
      'Service de la voirie',
      'Service incendie',
      'L’aqueduc',
      'Fosse septique',
      'Sécurité civile',
    ],
  },
  {
    label: 'Urbanisme et taxes',
    children: [
      'Urbanisme et réglementation municipale',
      'Évaluation et taxes',
      'Baux de villégiature',
      'Permis et certificats',
      'PerLE',
    ],
  },
  {
    label: 'Vie communautaire',
    children: [
      'Actualités',
      'Évènements',
      'Photos',
      'Bibliothèque',
      'Scolarité',
      'Formulaire',
      'Nous contacter',
    ],
  },
]
